var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6083 15.2326C18.1162 8.80261 43.978 10.0026 50.4265 15.7126C58.2811 22.6526 58.1842 48.5024 50.0096 53.2724C43.0278 57.3724 22.0435 58.4024 12.8216 52.5424C5.5974 47.9424 6.62531 22.2226 12.6083 15.2326Z",
    fill: "#839AD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6083 11.3332C18.1162 4.90316 43.978 6.10315 50.4265 11.8232C58.2811 18.7632 57.903 45.2432 50.0096 49.3832C43.3769 52.8532 22.0435 54.5032 12.8216 48.6432C5.5974 44.0432 6.62531 18.3232 12.6083 11.3332Z",
    fill: "#98ADE1",
    stroke: "#AAE7FE",
    strokeWidth: 0.87,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7576 21.3125L25.4773 31.4922L34.7576 41.6729",
    stroke: "#839AD6",
    strokeWidth: 6.93,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7576 20.0137L25.4773 30.1934L34.7576 40.373",
    stroke: "white",
    strokeWidth: 6.93,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M13.1235 17.3542C12.2799 15.3542 15.6834 12.6341 21.7537 11.2641C28.6385 9.71414 38.2385 10.9943 44.2506 12.3943C48.8858 13.4643 50.1563 16.0943 46.6266 15.2143C37.2302 12.8643 27.9695 12.6944 23.2762 15.4944C16.915 19.2944 14.2871 20.1342 13.1235 17.3542Z",
    fill: "url(#paint0_linear_1_1700)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3649 13.6641C12.4728 11.5741 19.6194 9.56407 20.1528 10.8741C20.6861 12.1841 13.9661 15.0841 13.3649 13.6641Z",
    fill: "#B3EBFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3852 10.5842C21.4822 8.72422 25.8556 8.81435 25.7586 9.96435C25.6616 11.1144 21.3174 11.8842 21.3852 10.5842Z",
    fill: "#B3EBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1700",
    x1: 12.9974,
    y1: 14.7742,
    x2: 48.6532,
    y2: 14.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98ADE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.1dda3c04d8558163f1ea71a9223f5a5e.svg";
export { ForwardRef as ReactComponent };